module.exports = __webpack_public_path__ + "static/img/logo.995a8ab9.png";